import { useLocation } from 'react-router-dom';

export default function SchemaOrg() {
  const location = useLocation();

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爱液视频',
    url: 'https://www.aiyeshipin.com',
    description: '爱液视频网站为您提供海量精选高清视频内容，汇聚多元化视频资源，支持在线流畅播放。',
    email: 'contact@aiyeshipin.com',
    telephone: '400-888-9999',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      streetAddress: '望京科技园A座18层',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爱液视频',
    url: 'https://www.aiyeshipin.com',
    description: '精选高清视频资源聚合平台',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.aiyeshipin.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const isHome = location.pathname === '/';
  const isCategory = location.pathname.startsWith('/category/');
  const isArticle = location.pathname.startsWith('/article/');
  const isAbout = location.pathname === '/about';

  let pageSchema = null;
  let breadcrumbSchema = null;
  let faqSchema = null;

  if (isHome) {
    pageSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '爱液视频 - 精选高清视频资源聚合平台',
      description: '爱液视频网站为您提供海量精选高清视频内容，汇聚多元化视频资源。',
      url: 'https://www.aiyeshipin.com/',
      isPartOf: { '@id': 'https://www.aiyeshipin.com/#website' },
      about: { '@id': 'https://www.aiyeshipin.com/#organization' },
    };

    breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://www.aiyeshipin.com/',
        },
      ],
    };

    faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '爱液视频网站需要注册才能观看吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '不需要注册！爱液视频网站上的大部分内容都可以免费在线观看，无需注册账号。',
          },
        },
        {
          '@type': 'Question',
          name: '视频播放支持哪些清晰度？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '爱液视频网站支持从标清到超高清多种清晰度选择，包括480P、720P、1080P以及4K超高清画质。',
          },
        },
        {
          '@type': 'Question',
          name: '可以在手机上观看爱液视频吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '当然可以！爱液视频网站采用响应式设计，完美适配手机、平板和电脑等各种设备。',
          },
        },
        {
          '@type': 'Question',
          name: '网站上的视频内容多久更新一次？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '我们的内容团队每天都会更新视频资源，确保您能看到最新、最热门的精选内容。',
          },
        },
        {
          '@type': 'Question',
          name: '如何找到我喜欢的视频类型？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以通过首页的分类导航快速定位感兴趣的视频类型，包括动作、喜剧、剧情、科幻、纪录和动漫等分类。',
          },
        },
        {
          '@type': 'Question',
          name: '视频加载慢或卡顿怎么办？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '建议检查网络连接、降低清晰度、清除浏览器缓存后重试。CDN加速网络覆盖全国，通常能保证流畅播放。',
          },
        },
      ],
    };
  }

  const schemas = [organizationSchema, websiteSchema];
  if (pageSchema) schemas.push(pageSchema);
  if (breadcrumbSchema) schemas.push(breadcrumbSchema);
  if (faqSchema) schemas.push(faqSchema);

  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}